import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    ctaSubmit: 'Next',
    description: {
      mandatee:
        'This information should be identical to that indicated in the draft statutes.',
      nonMandatee:
        'This information should be identical to that indicated in your draft statutes.',
    },
    title: {
      mandatee: {
        default: 'What is the company address?',
        fill: 'Type the company’s address',
        verify: 'Please verify the company’s address',
      },
      nonMandatee: {
        default: 'What is your company’s address?',
        fill: 'Type the company’s address',
        verify: 'Please verify your company’s address',
      },
    },
  },
  fr: {
    ctaSubmit: 'Suivant',
    description: {
      mandatee:
        'Ces informations doivent correspondre exactement à celles qui figurent dans le projet de statuts de la société.',
      nonMandatee:
        'Ces informations doivent correspondre exactement à celles qui figurent dans le projet de statuts de votre société.',
    },
    title: {
      mandatee: {
        default: 'Quelle sera l’adresse de la société\u00A0?',
        fill: 'Saisissez l’adresse de la société',
        verify: 'Veuillez vérifier l’adresse de la société',
      },
      nonMandatee: {
        default: 'Quelle sera l’adresse de votre société\u00A0?',
        fill: 'Saisissez l’adresse de votre société',
        verify: 'Veuillez vérifier l’adresse de votre société',
      },
    },
  },
} as const);
